import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { Checkboxes } from '../../../FlowConfigurationInputs';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Semih Yildiz
 */
function WriteRange({ action, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.WRITE-RANGE.';
    const [rangeType, setRangeType] = useState();

    useEffect(() => {
        // Assign initial values
        // if (!action.fields.range) {
        //     action.fields.range = { value: '', isRequired: true };
        // }
        // if (!action.fields.rangeType || action.fields.rangeType?.value === '') {
        //     action.fields.rangeType = { value: 'custom' }
        //     setRangeType('custom')
        // } else {
        //     setRangeType(action.fields.rangeType?.value);
        // }
        // if (!action.fields.value) {
        //     action.fields.value = { value: '', isRequired: true };
        // }
    }, [action]);

    function changeRangeType(v) {
        action.fields.rangeType = { value: v }
        setRangeType(v);
    }

    return (
        <>
            <div className="form-element">
                <div className="form-element">
                    {t(label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element">
                {t(label + 'DATA-SOURCE')}
                <VariablePicker action={action} inputName="datatableSource" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'RANGE')}
                <TextInput action={action} inputName="range" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired />
                <em className="form-element-eg">{t(rangeType === 'custom' ? label + 'RANGE-EG' : label + 'COLUMN-EG')}</em>
            </div>
        </>
    )
}

export default WriteRange;